/** * 系统操作日志-导出日志 */
<template>
	<div>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="导出人：">
				<el-select v-model="formInline.createUserId" placeholder="请选择导出人" clearable size="small" filterable>
					<el-option v-for="item in operatorList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="导出时间：">
				<el-date-picker
					v-model="timeData"
					size="small"
					value-format="yyyy-MM-dd"
					type="daterange"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@change="timeChange"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="描述：">
				<el-input v-model="formInline.content" size="small" placeholder="请输入描述关键字" clearable @keyup.enter.native="search"></el-input>
			</el-form-item>
			<el-form-item class="btnList">
				<el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</el-form-item>
		</el-form>
		<!--列表-->
		<STable :columns="columnsData" :data="listData" :loading="loading" :row-key="'keyId'" @get-data="getListData"></STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetExportLogPageList } from "../../../api/exportHistoryApi.js";
import { GetUserInfoSimpleDropList } from "@/api/userApi.js";

export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				createUserId: "",
				startTime: null,
				endTime: null,
				content: ""
			},
			operatorList: [],
			listData: [],
			timeData: [],
			columnsData: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60"
				},
				{
					prop: "creator",
					label: "导出人",
					align: "center",
					width: "120"
				},
				{
					prop: "content",
					label: "描述"
				},
				{
					prop: "createTime",
					label: "导出时间",
					align: "center",
					width: "170",
					formatter: (row, column, cellValue) => {
						if (!cellValue) return "";
						return String(cellValue).replace("T", " ").substring(0, 19);
					}
				}
			]
		};
	},
	// 注册组件
	components: {},
	/**
	 * 创建完毕
	 */
	created() {
		this.getListData();
		this.getOperatorList();
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		timeChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.timeData = [];
			this.search();
		},
		// 查询
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		//获取导出人信息
		getOperatorList() {
			GetUserInfoSimpleDropList({})
				.then((res) => {
					if (res.code == 1) {
						this.operatorList = res.data.map((item) => ({
							keyId: item.keyId,
							value: item.chName
						}));
					} else {
						this.$message({
							type: "info",
							message: "暂无数据"
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetExportLogPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.pageparm.total = 0;
						this.$message({
							type: "info",
							message: "暂无数据"
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
